import { render, staticRenderFns } from "./OrderTracking.vue?vue&type=template&id=5c44d2aa&scoped=true&"
import script from "./OrderTracking.vue?vue&type=script&lang=js&"
export * from "./OrderTracking.vue?vue&type=script&lang=js&"
import style0 from "./OrderTracking.vue?vue&type=style&index=0&id=5c44d2aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c44d2aa",
  null
  
)

export default component.exports